const formatBoolean = value => (value ? 'Yes' : 'No');

export default formatBoolean;
